module.exports = __webpack_public_path__ + "img/inoue-channel.a9952e1f.gif";